'use strict';

import { padEnd, isEmpty, isString } from 'lodash';

const logLevels = ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR'];

let defaultLogLevel = 'INFO';
var minLogLevel = defaultLogLevel;
var moduleIdLevels = {};

function _setLevel(level) {
  if (logLevels.indexOf(level) >= 0) {
    minLogLevel = level;
  }
}

function _setLevelForModuleId(level, moduleId) {
  if (logLevels.indexOf(level) >= 0) {
    moduleIdLevels[moduleId] = level;
  }
}

export default function Logger(moduleId) {
  var moduleName = isString(moduleId)
    ? moduleId.split('/').slice(-1).pop().trim()
    : '-';

  function _log(logLevel, args) {
    var _logLevel = logLevel === undefined ? defaultLogLevel : logLevel;
    var _minLogLevel =
      moduleIdLevels[moduleId] === undefined
        ? minLogLevel
        : moduleIdLevels[moduleId];
    // check for globs
    let matchingGlobs = Object.keys(moduleIdLevels).filter((x) => {
      return moduleId.match(new RegExp(x, 'gi'));
    });
    if (matchingGlobs.length > 0) {
      _minLogLevel = matchingGlobs[0].level;
    }

    if (logLevels.indexOf(_logLevel) >= logLevels.indexOf(_minLogLevel)) {
      let lowerCaseLogLevel = _logLevel.toLowerCase();
      if (console[lowerCaseLogLevel] instanceof Function) {
        console[lowerCaseLogLevel](
          padEnd(_logLevel, 6) + ' [ ' + moduleName + ' ]:',
          ...args
        );
      } else {
        console.log(padEnd(_logLevel, 6) + ' [ ', moduleName + ' ]:', ...args);
      }
    }
  }

  return {
    info: function () {
      _log('INFO', arguments);
    },
    debug: function () {
      _log('DEBUG', arguments);
    },
    error: function () {
      _log('ERROR', arguments);
    },
    setLevel: function (level, moduleId) {
      if (!moduleId) {
        _setLevel(level);
      } else {
        _setLevelForModuleId(level, moduleId);
      }
    },
  };
}
